import moment from "moment";
import { formatDate, formatDateTime, formatMonthWithoutUtc, formatMonthYear } from "../appconfig/AppHelper";
import { Avatar } from "primereact/avatar";
import { Calendar } from "primereact/calendar";
import { Badge } from "primereact/badge";

export const formatPageDate = function (date: any) {
  return date ? moment.utc(date).format("DD MMM YYYY") : null;
};

export const titleTemplate = (rowData: any) => {
  return (
    <div className="flex gap-1 avatar-div align-items-center">
      {!window.cn(rowData?.img) ? (
        <Avatar style={{ flex: "0 0 auto" }} image={rowData?.img} shape="circle" />
      ) : (
        <Avatar icon="pi pi-user" shape="circle" />
      )}
      <div className="ml-2 emp-name link-name">{rowData.title}</div>
    </div>
  );
};

// name template
export const nameTemplate = (rowData: any) => {
  return (
    <div className="name">
      {rowData.first_name} {rowData.last_name}
    </div>
  );
};

// name and company template
export const nameCompanyTemplate = (rowData: any) => {
  const name = rowData.first_name || rowData.last_name ? `${rowData.first_name ?? ""} ${rowData.last_name ?? ""}` : rowData.company_name || "-";

  return <div className="name">{name}</div>;
};

export const wageBodyTemplate = (rowData: any) => {
  return <div className="name">${rowData.wage}</div>;
};

export const dollarTemplate = (rowData: any, rowIndex: any) => {
  const value = rowData[rowIndex.field];
  return <div>{value ? `$${value}` : "-"}</div>;
};

// holiday name template
export const holidayNameTemplate = (rowData: any) => {
  return <div className="name">{rowData.name}</div>;
};

// employee name template
export const employeeNameTemplate = (rowData: any) => {
  return (
    <div className="name">
      {rowData.employee_data.first_name} {rowData.employee_data.last_name}
    </div>
  );
};

// employee name template
export const employeeT4NameTemplate = (rowData: any) => {
  return (
    <div className="name">
      {rowData.employees.first_name} {rowData.employees.last_name}
    </div>
  );
};

// user name template
export const userTemplate = (user: any) => {
  return user ? (
    <div className="name">
      {user.first_name} {user.last_name}
    </div>
  ) : (
    ""
  );
};

// client name template
export const clientTemplate = (client: any) => {
  return client ? (
    <div className="name">
      {client.first_name} {client.last_name}
    </div>
  ) : (
    "-"
  );
};

// address template
export const addressTemplate = (rowData: any) => {
  return (
    <div>
      {rowData.address} {rowData.city} {rowData.province} {rowData.postal_code}
    </div>
  );
};

// payperiod Start And End date
export const payPeriodTemplate = (rowData: any) => {
  return (
    <div className="name">
      {formatDate(rowData.start_date)} - {formatDate(rowData.end_date)}
    </div>
  );
};

//salary template
export const salaryTemplate = (rowData: any) => {
  return (
    <div className="actions">
      {rowData?.is_salary ? <Badge severity="success" value="Yes" style={{ width: "fit-content" }}></Badge> : <Badge severity="danger" value="No" style={{ width: "fit-content" }}></Badge>}
    </div>
  );
};

// payperiod Start And End date
export const payCycleTemplate = (rowData: any) => {
  return (
    <div className="name">
      {formatDate(rowData.starting_date)} - {formatDate(rowData.ending_date)}
    </div>
  );
};

// date dynamic template
export const dateTemplate = (rowData: any, rowIndex: any) => {
  const value = rowData[rowIndex.field];
  return <div>{value ? formatDate(value) : "-"}</div>;
};

// date dynamic template without utc
export const dateTemplateWithoutUtc = (rowData: any, rowIndex: any) => {
  const value = rowData[rowIndex.field];
  return <div>{value ? formatMonthWithoutUtc(value) : "-"}</div>;
};

// export const month year template
export const dateMonthYearTemplate = (rowData: any, rowIndex: any) => {
  const value = rowData[rowIndex.field];
  return <div>{value ? formatMonthYear(value) : "-"}</div>;
};

// date time dynamic template
export const dateTimeTemplate = (rowData: any, rowIndex: any) => {
  return (
    <>
      <div>{formatDateTime(rowData[rowIndex.field])}</div>
    </>
  );
};

// return month from date
export const monthTemplate = (rowData: any) => {
  const apiDate = rowData?.pay_check_date;
  if (!apiDate) {
    return "-";
  } else {
    const monthName = moment(apiDate).format("MMMM");
    return (
      <>
        <div>{monthName}</div>
      </>
    );
  }
};

// amount (wage) in $
export const amountTemplate = (rowData: any) => {
  return rowData ? (
    <>
      <div>
        <span>{rowData.wage ? `$${rowData.wage}` : "-"}</span>
      </div>
    </>
  ) : (
    "-"
  );
};

// pdf created date time
export const createdAtTemplate = (rowData: any) => {
  return (
    <>
      <div>{formatDateTime(rowData?.createdAt)}</div>
    </>
  );
};

//Empty Temlate for image upload
export const emptyTemplate = (rowData: any) => {
  return <div className="flex align-items-center flex-column">{rowData?.pay_period ? rowData?.pay_period : "-"}</div>;
};

// global field template
export const globalFieldTemplate = (rowData: any, rowIndex: any) => {
  return <span>{!window.cn(rowData[rowIndex.field]) ? rowData[rowIndex.field] : "-"}</span>;
};

// contractor template
export const createContractorTemplate = (field: string) => (rowData: any) => {
  const value = rowData?.contractor_data?.[field];

  const displayValue = field === "gst_no" || field === "sin_no" ? value?.toUpperCase() ?? "-" : value ?? "-";

  return <div className="name">{displayValue}</div>;
};

// date filter template dynamic
export const dateFilterTemplate = (options: any) => {
  return (
    <Calendar
      selectionMode="range"
      value={options.value}
      onChange={(e) => options.filterApplyCallback(e.value)}
      dateFormat="dd/mm/yy"
      placeholder="Select Date"
      showIcon
    />
  );
};

// dynamic field template

export const commonFieldTemplate = (rowData: any, rowIndex: any) => {
  const value = rowData[rowIndex.field]?.toUpperCase();
  return <div>{value ? value : "-"}</div>;
};

// dynamic nested fied template
export const commonNestedFieldTemplate = (field: any) => (rowData: any) => {
  const value = rowData?.employee?.[field];
  return <div className="name">{value}</div>;
};
